import type { ComponentProps } from 'react';

type Props = {
  size?: number;
} & ComponentProps<'svg'>;

export const OriginalTableOfContentIcon = ({ size = 16, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.66602 11.335C5.03328 11.335 5.33105 11.6327 5.33105 12C5.33105 12.3673 5.03328 12.665 4.66602 12.665H2C1.63273 12.665 1.33496 12.3673 1.33496 12C1.33496 11.6327 1.63273 11.335 2 11.335H4.66602ZM8.66602 7.33496C9.03329 7.33496 9.33105 7.63273 9.33105 8C9.33105 8.36727 9.03329 8.66504 8.66602 8.66504H2C1.63273 8.66504 1.33496 8.36727 1.33496 8C1.33496 7.63273 1.63273 7.33496 2 7.33496H8.66602ZM14 3.33496C14.3673 3.33496 14.665 3.63273 14.665 4C14.665 4.36727 14.3673 4.66504 14 4.66504H2C1.63273 4.66504 1.33496 4.36727 1.33496 4C1.33496 3.63273 1.63273 3.33496 2 3.33496H14Z"
        fill="currentColor"
      />
    </svg>
  );
};
